import partial from './partial.js';
import delay from './delay.js';
import _ from './underscore.js';

// Defers a function, scheduling it to run after the current call stack has
// cleared.
export default partial(delay, _, 1);



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/defer.js
// module id = 927
// module chunks = 0